import React, { useCallback, useState } from 'react';
import './index.scss';
import Layout from "@/Hoc/Layout";
import SubMenu from '@/Components/SubMenu';
import services from '@/services';
import ArticleList from './ArticleList';
import PerspectiveList from './PerspectiveList';
import AnimatedMain from '@/Hoc/AnimatedMain';
import Loading from '@/Components/Loading';

const Page = () => {
    let [ UITemplate, updateUITemplate ] = useState(null);
    let [ isLoading, updateIsLoading ] = useState(true);

    let setUpPage = useCallback(async (currentSelectedSubMenuId, currentSubMenu) => {
        if (!currentSubMenu) return;
        let articleList = await services.Perspective.fetchArticleList(currentSelectedSubMenuId);
        let banner = await services.Perspective.fetchBanner(currentSelectedSubMenuId);
        let Template = ({ PerspectiveList })[currentSubMenu.UITemplate] || ArticleList;
        updateUITemplate(<Template articleList={ articleList.data } banner={ banner?.data?.data?.attributes?.banner?.data?.attributes?.url }/>);
        updateIsLoading(false);
    }, []);

    return (
        <React.Fragment>
            <aside className="page-aside">
                <SubMenu onCurrentSelectedSubMenuIDChanged={setUpPage}/>
            </aside>
            <main className="page-main">
                { isLoading ? <Loading /> : null }
                <AnimatedMain>
                    { UITemplate }
                </AnimatedMain>
            </main>
        </React.Fragment>
    );
};

export default Layout({ name: 'perspective' })(Page);
